import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  :root{
    --purple-primary: #554dde;
    --accent-blue: #7199ff;
    --dark-blue: #554dde;
    --deep-blue: #3C4E8C;
    --neutral-light: #f7faff;
    --lavender-secondary: #6b6d9e;
    --dark-primary: #161950;
    --border-colour: #cad6f1;
    
  }
  *{
    margin: 0;
    padding: 0;
    list-style: none;
    box-sizing: border-box;
    font-family: 'Rubik', sans-serif;
    text-decoration: none;
  }

  body{
    background-color: var(--neutral-light);
    color: white;
    font-size: 1.2rem;
  }
  a{
    color: inherit;
  }
  p{
    color: var(--dark-primary);
    line-height: 1.8rem;
  }

  .primary-heading{
    font-size: 4rem;
    color: #fff;
  }

  .secondary-heading{
    font-size: 3rem;
    color: var(--accent-blue);
  }

   .small-heading{
        font-size: 2.5rem;
        color: var(--purple-primary);
        text-align: center;
    }
    span{
        color: var(--accent-blue);
    }

    html{
      scroll-behavior: smooth;
    }

`;

export default GlobalStyle;
